export default "__VITE_ASSET__ChRAyCDB__"